import { useCallback, useState } from "react";
import { importMatches } from "../../../api/index.js";
import { deleteMatches } from "../../../api/index.js";
import ImportCSV from "./ImportCSV.js";
import { CircularProgress, Typography, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, TablePagination, Button } from "@mui/material";


const MatchesRugbyCSV = () => {
    const [loading, setLoading] = useState(false);
    const [response, setResponse] = useState([]);
    const [responseMatches, setResponseMatches] = useState([]);
    const [selectedMatches, setSelectedMatches] = useState([]);
    const [importComplete, setImportComplete] = useState(false);
    const [selectAll, setSelectAll] = useState(false);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [page, setPage] = useState(0);
    const handleChangePage = (event, newPage) => {
      setPage(newPage);
    };
    
    const handleMatchesImport = useCallback(async (rows) => {
      setLoading(true);
      try {
          // TODO add template name from parent MatchesCSV
          const { data } = await importMatches(rows, 'rugby', 'FFR');
          setResponseMatches((prevResponse) => prevResponse.concat(data.matches));
          setResponse((prevResponse) => prevResponse.concat(data.message));
      } catch (error) {
          console.error(error);
          setResponse([error.message]);
      }
      setLoading(false);
  }, []);

    const handleBulkDelete = async () => {
      setLoading(true);
      setResponse([]);

      try {
          const { data } = await deleteMatches(selectedMatches);
          setResponse((prevResponse) => prevResponse.concat(data));
      } catch (error) {
          console.error(error);
          setResponse([error.message]);
      }
      setLoading(false);
      setSelectedMatches([]);
      setResponseMatches([]);

    };

    const handleImportComplete = () => {
        // Set importComplete after the entire import is complete
        setImportComplete(true);
    };

    const handleSelectAll = () => {
      if (selectAll) {
        // Deselect all
        setSelectedMatches([]);
      } else {
        // Select all
        const allMatchIds = responseMatches.map((match) => match._id);
        setSelectedMatches(allMatchIds);
      }
      setSelectAll(!selectAll);
    };

    const handleSelect = (matchId) => {
      const isSelected = selectedMatches.includes(matchId);
      let newSelected = [];
    
      if (!isSelected) {
        newSelected = [...selectedMatches, matchId];
      } else {
        newSelected = selectedMatches.filter((id) => id !== matchId);
      }
    
      setSelectedMatches(newSelected);
    };

    const handleChangeRowsPerPage = (event) => {
      setRowsPerPage(parseInt(event.target.value, 10));
      setPage(0); // Reset the page to 0 when changing rowsPerPage
    };


    return <div>
        <Typography variant="h2">Matchs</Typography>
    <ImportCSV
      columns={[
        { id: 'thirdPartyId', label: 'Identifiant Tiers' },
        { id: 'season', label: 'Saison' },
        { id: 'competitionName', label: 'Nom de la compétition' },
        { id: 'competitionThirdPartyId', label: 'Identifiant Tiers - Compétition' },
        { id: 'day', label: 'Jour' },
        { id: 'poule', label: 'Poule' },
        { id: 'status', label: 'Statut' },
        { id: 'dateTime', label: 'Date et heure' },
        { id: 'discipline', label: 'Discipline' },
        { id: 'homeTeam', label: 'Equipe locale' },
        { id: 'homeTeamThirdPartyId', label: 'Identifiant Tiers - Equipe locale' },
        { id: 'awayTeam', label: 'Equipe visiteur' },
        { id: 'awayTeamThirdPartyId', label: 'Identifiant Tiers - Equipe visiteur' },
        { id: 'homeTeamScore', label: 'Score équipe locale' },
        { id: 'awayTeamScore', label: 'Score équipe visiteur' },
        { id: 'thirdPartyEntityId', label: 'Identifiant Tiers - Rencontre' },
        { id: 'provider', label: 'Fournisseur' },
      ]}
      process={handleMatchesImport}
      onComplete={handleImportComplete}
    />
     {loading && <CircularProgress />}

            {importComplete && response && response.map((r, index) => <p key={index}>{r}</p>)}

            {importComplete && responseMatches.length > 0 && (
              <div style={{ paddingTop: '15px', paddingBottom: '40px' }}>
                <Typography variant="h4">Matchs importés</Typography>
                <TableContainer component={Paper}>
                  <Table>
                    <TableHead>
                      <TableRow>
                        <TableCell>
                          <input
                            type="checkbox"
                            checked={selectAll}
                            onChange={() => handleSelectAll()}
                          />
                        </TableCell>
                        {Object.keys(responseMatches[0]).map((property) => (
                          <TableCell key={property}>{property}</TableCell>
                        ))}
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {responseMatches.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((match, index) => (
                        <TableRow key={index}>
                          <TableCell>
                            <input
                              type="checkbox"
                              checked={selectedMatches.includes(match._id)}
                              onChange={() => handleSelect(match._id)}
                            />
                          </TableCell>
                          {Object.values(match).map((value, colIndex) => (
                            <TableCell key={colIndex}>{value}</TableCell>
                          ))}
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
                <TablePagination
                  rowsPerPageOptions={[10, 25, 50, { label: 'All', value: -1 }]}
                  component="div"
                  count={responseMatches.length}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  onPageChange={handleChangePage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                />
                <Button variant="contained" onClick={handleBulkDelete}>
                  Supprimer
                </Button>
              </div>
            )}


            
      </div>
}

export default MatchesRugbyCSV